//
//
//
//
//
//
//
//
//

export default {
    props: {
        name: String,
        icon: String,
        label: String,
        disable: Boolean,
        hide: Boolean,
        noScroll: Boolean,
    },
};
